const SDK_VERSION = '7.120.3';
export { SDK_VERSION };
